module.exports = __webpack_public_path__ + "static/img/home-purpose.7d046d3b.svg";